export const sem1_2023_2024 = [
  {
    id: 1,
    opp: "Classes start",
    beginDate: "9 sept, 2023",
    endDate: "03 nov, 2023",
    duration: "8 weeks",
  },
  {
    id: 2,
    opp: "Thesis defense period",
    beginDate: "5 august, 2023",
    endDate: "27 oct, 2023",
    duration: "",
  },
  {
    id: 3,
    opp: "Graduation day",
    beginDate: "15 oct, 2023",
    endDate: "15 oct, 2023",
    duration: "",
  },
  {
    id: 4,
    opp: "Mid term exam",
    beginDate: "04 nov, 2023",
    endDate: "10 nov, 2023",
    duration: "1 week",
  },
  {
    id: 5,
    opp: "Class resume",
    beginDate: "11 nov, 2023",
    endDate: "29 Dec, 2023",
    duration: "7 weeks",
  },
  {
    id: 6,
    opp: "Final exam period",
    beginDate: "30 dec, 2023",
    endDate: "12 jan, 2024",
    duration: "2 weeks",
  },
  {
    id: 7,
    opp: "Semester vacation",
    beginDate: "13 jan, 2024",
    endDate: "03 nov, 2024",
    duration: "2 weeks",
  },
  {
    id: 8,
    opp: "Submision exam Result sheet",
    beginDate: "13 Jan, 2024",
    endDate: "19 Jan, 2024",
    duration: "1 week",
  },
  {
    id: 9,
    opp: "Final exam data entry",
    beginDate: "20 jan, 2024",
    endDate: "26 jan, 2024",
    duration: "1 week",
  },
  {
    id: 10,
    opp: "Aproving exam result on academic counsel",
    beginDate: "29 jan, 2024",
    endDate: "",
    duration: "",
  },
  {
    id: 11,
    opp: "Exam aproval notification",
    beginDate: "30 jan, 2024",
    endDate: "",
    duration: "",
  },
  {
    id: 12,
    opp: "Re-exam period",
    beginDate: "03 Feb, 2024",
    endDate: "09 Feb, 2024",
    duration: "1 week",
  },
  {
    id: 13,
    opp: "Class start semester 2",
    beginDate: "10 Feb, 2024",
    endDate: "",
    duration: "",
  },
];
export const sem2_2023_2024 = [
  {
    id: 1,
    opp: "Classes start",
    beginDate: "17 Feb, 2024",
    endDate: "19 April, 2024",
    duration: "7 weeks",
  },
  {
    id: 2,
    opp: "Eid Al-Fitri vacation",
    beginDate: "30 March, 2024",
    endDate: "12 Apr, 2024",
    duration: "2 weeks",
  },
  {
    id: 3,
    opp: "Mid term exam",
    beginDate: "20 Apr, 2024",
    endDate: "26 Apr, 2024",
    duration: "1 week",
  },
  {
    id: 4,
    opp: "Classes resume",
    beginDate: "27 Apr, 2024",
    endDate: "14 June, 2024",
    duration: "7 weeks",
  },
  {
    id: 5,
    opp: "Eid Al-adha vacation",
    beginDate: "15 June, 2024",
    endDate: "29 June, 2024",
    duration: "2 weeks",
  },
  {
    id: 6,
    opp: "Final exam period",
    beginDate: "29 June, 2024",
    endDate: "05 July, 2024",
    duration: "1 weeks",
  },
  {
    id: 7,
    opp: "Oral exam period",
    beginDate: "06 July, 2024",
    endDate: "12 July, 2024",
    duration: "1 weeks",
  },
  {
    id: 8,
    opp: "Semester vacation",
    beginDate: "13 July, 2024",
    endDate: "06 Sep, 2024",
    duration: "8 weeks",
  },
  {
    id: 9,
    opp: "Submision exam Result sheet",
    beginDate: "13 July, 2024",
    endDate: "19 July, 2024",
    duration: "1 week",
  },
  {
    id: 10,
    opp: "Final exam data entry",
    beginDate: "20 July, 2024",
    endDate: "26 July, 2024",
    duration: "1 week",
  },
  {
    id: 11,
    opp: "Aproving exam result on academic counsel",
    beginDate: "29 July, 2024",
    endDate: "",
    duration: "",
  },
  {
    id: 12,
    opp: "Exam aproval notification",
    beginDate: "30 July, 2024",
    endDate: "",
    duration: "",
  },
  {
    id: 13,
    opp: "Thesis Defense Period",
    beginDate: "05 Aug, 2024",
    endDate: "26 Oct, 2024",
    duration: "",
  },
  {
    id: 14,
    opp: "Re-exam period",
    beginDate: "24 Aug, 2024",
    endDate: "30 Aug, 2024",
    duration: "1 week",
  },
  {
    id: 15,
    opp: "Class start 2024 - 2025",
    beginDate: "14 Sep, 2024",
    endDate: "",
    duration: "",
  },
];

export const sem1_2024_2025 = [
  {
    id: 1,
    opp: "Start of the first semester",
    beginDate: "14 Sep, 2024",
    endDate: "31 Jan, 2025",
    duration: "",
  },
  {
    id: 2,
    opp: "Classes begin",
    beginDate: "14 Sep, 2024",
    endDate: "8 Nov, 2024",
    duration: "8 weeks",
  },
  {
    id: 3,
    opp: "Mid term exam",
    beginDate: "09 Nov, 2024",
    endDate: "15 Nov, 2024",
    duration: "1 week",
  },
  {
    id: 4,
    opp: "Classes resume",
    beginDate: "16 Nov, 2024",
    endDate: "03 Jan, 2025",
    duration: "7 weeks",
  },
  {
    id: 5,
    opp: "Exam reading break",
    beginDate: "03 Jan, 2025",
    endDate: "10 Jan, 2025",
    duration: "1 week",
  },
  {
    id: 5,
    opp: "Final exam period",
    beginDate: "11 Jan, 2025",
    endDate: "17 Jan, 2025",
    duration: "1 week",
  },
  {
    id: 6,
    opp: "University transfere application begin",
    beginDate: "18 Jan, 2025",
    endDate: "13 Feb, 2025",
    duration: "4 weeks",
  },
  {
    id: 7,
    opp: "Oral exam period",
    beginDate: "18 Jan, 2025",
    endDate: "25 Jan, 2025",
    duration: "1 week",
  },
  {
    id: 8,
    opp: "Publication of exam results",
    beginDate: "24 Jan, 2024",
    endDate: "",
    duration: "",
  },
  {
    id: 9,
    opp: "Re-exam period",
    beginDate: "25 Jan, 2025",
    endDate: "31 Jan, 2025",
    duration: "1 week",
  },
  {
    id: 10,
    opp: "Publication of re-exam results",
    beginDate: "01 Feb, 2025",
    endDate: "",
    duration: "",
  },
  {
    id: 11,
    opp: "Break begin",
    beginDate: "01 Feb, 2025",
    endDate: "14 Feb, 2025",
    duration: "2 weeks",
  },
];

export const sem2_2024_2025 = [
  {
    id: 1,
    opp: "Start of the second semester",
    beginDate: "15 Feb, 2025",
    endDate: "04 July, 2025",
    duration: "",
  },
  {
    id: 2,
    opp: "Classes begin",
    beginDate: "15 Feb, 2025",
    endDate: "21 March, 2025",
    duration: "5 weeks",
  },
  {
    id: 3,
    opp: "Eid Al-Fitri vacation",
    beginDate: "22 March, 2025",
    endDate: "04 Apr, 2025",
    duration: "2 week",
  },
  {
    id: 4,
    opp: "Classes resume",
    beginDate: "05 Apr, 2025",
    endDate: "25 Apr, 2025",
    duration: "3 weeks",
  },
  {
    id: 5,
    opp: "Mid term exam",
    beginDate: "26 Apr, 2025",
    endDate: "02 May, 2025",
    duration: "1 week",
  },
  {
    id: 6,
    opp: "Classes resume",
    beginDate: "03 May, 2025",
    endDate: "06 June, 2025",
    duration: "5 weeks",
  },
  {
    id: 7,
    opp: "Eid Al-adha vacation",
    beginDate: "07 June, 2025",
    endDate: "20 June, 2025",
    duration: "2 week",
  },
  {
    id: 8,
    opp: "Classes resume",
    beginDate: "21 June, 2025",
    endDate: "27 June, 2025",
    duration: "1 weeks",
  },
  {
    id: 9,
    opp: "Final exam period",
    beginDate: "28 June, 2025",
    endDate: "04 July, 2025",
    duration: "1 week",
  },
  {
    id: 10,
    opp: "Oral exam period",
    beginDate: "05 July, 2025",
    endDate: "11 July, 2025",
    duration: "1 week",
  },
  {
    id: 11,
    opp: "Re-exam period",
    beginDate: "12 July, 2025",
    endDate: "18 July, 2025",
    duration: "1 week",
  },
  {
    id: 12,
    opp: "Summer break begin",
    beginDate: "19 July, 2025",
    endDate: "",
    duration: "",
  },
  {
    id: 13,
    opp: "University transfere application term",
    beginDate: "02 Aug, 2025",
    endDate: "31 Aug, 2024",
    duration: "",
  },
  {
    id: 14,
    opp: "Thesis defense Period",
    beginDate: "07 Aug, 2025",
    endDate: "24 Oct, 2025",
    duration: "",
  },
  {
    id: 15,
    opp: "Class start 2025 - 2026",
    beginDate: "13 Sep, 2025",
    endDate: "",
    duration: "",
  },
];

export const sem1_2025_2026 = [
  {
    id: 1,
    opp: "Start of First Semester",
    beginDate: "13 Sep, 2025",
    endDate: "23 Jan, 2026",
    duration: "",
  },
  {
    id: 2,
    opp: "Classes begin",
    beginDate: "13 Sep, 2025",
    endDate: "07 Nov, 2025",
    duration: "8 weeks",
  },
  {
    id: 3,
    opp: "Midterm Exams",
    beginDate: "08 Nov, 2025",
    endDate: "14 Nov, 2025",
    duration: "1 week",
  },
  {
    id: 4,
    opp: "Classes resume",
    beginDate: "15 Nov, 2025",
    endDate: "26 Dec, 2025",
    duration: "7 weeks",
  },
  {
    id: 5,
    opp: "Final Exams",
    beginDate: "27 Dec, 2025",
    endDate: "02 Jan, 2026",
    duration: "1 week",
  },
  {
    id: 6,
    opp: "Oral Exams",
    beginDate: "03 Jan, 2026",
    endDate: "09 Jan, 2026",
    duration: "1 week",
  },
  {
    id: 7,
    opp: "University Transfer Application",
    beginDate: "11 Jan, 2026",
    endDate: "05 Feb, 2026",
    duration: "4 weeks",
  },
  {
    id: 8,
    opp: "Publication of Exam Results",
    beginDate: "17 Jan, 2026",
    endDate: "",
    duration: "",
  },
  {
    id: 9,
    opp: "Re-exams",
    beginDate: "17 Jan, 2026",
    endDate: "23 Jan, 2026",
    duration: "1 week",
  },
  {
    id: 10,
    opp: "End of First Semester",
    beginDate: "23 Jan, 2026",
    endDate: "",
    duration: "",
  },
  {
    id: 11,
    opp: "Break begin",
    beginDate: "25 Jan, 2026",
    endDate: "13 Feb, 2026",
    duration: "3 weeks",
  },
  {
    id: 12,
    opp: "Publication of Re-Exam Results",
    beginDate: "28 Jan, 2026",
    endDate: "",
    duration: "",
  },
];

export const sem2_2025_2026 = [
  {
    id: 1,
    opp: "Start of the second semester",
    beginDate: "14 Feb, 2026",
    endDate: "10 Jul, 2026",
    duration: "",
  },
  {
    id: 2,
    opp: "Classes begin",
    beginDate: "14 Feb, 2026",
    endDate: "13 Mar, 2026",
    duration: "4 weeks",
  },
  {
    id: 3,
    opp: "Ramadan & Eid Al-Fitr Vacation",
    beginDate: "10 Mar, 2026",
    endDate: "23 Mar, 2026",
    duration: "2 weeks",
  },
  {
    id: 4,
    opp: "Classes resume",
    beginDate: "24 Mar, 2026",
    endDate: "24 Apr, 2026",
    duration: "4 weeks",
  },
  {
    id: 5,
    opp: "Mid-Term Examination Period",
    beginDate: "18 Apr, 2026",
    endDate: "24 Apr, 2026",
    duration: "1 week",
  },
  {
    id: 6,
    opp: "Classes resume",
    beginDate: "25 Apr, 2026",
    endDate: "22 May, 2026",
    duration: "3 weeks",
  },
  {
    id: 7,
    opp: "Eid al-Adha Vacation",
    beginDate: "23 May, 2026",
    endDate: "29 May, 2026",
    duration: "1 week",
  },
  {
    id: 8,
    opp: "Classes resume",
    beginDate: "30 May, 2026",
    endDate: "12 Jun, 2026",
    duration: "2 weeks",
  },
  {
    id: 9,
    opp: "Final Examination Period",
    beginDate: "29 Jun, 2026",
    endDate: "05 Jul, 2026",
    duration: "1 week",
  },
  {
    id: 10,
    opp: "Oral Examination Period",
    beginDate: "06 Jul, 2026",
    endDate: "12 Jul, 2026",
    duration: "1 week",
  },
  {
    id: 11,
    opp: "Re-Examination Period",
    beginDate: "25 Jul, 2026",
    endDate: "31 Jul, 2026",
    duration: "1 week",
  },
  {
    id: 12,
    opp: "Summer Break Begins",
    beginDate: "18 Jul, 2026",
    endDate: "",
    duration: "",
  },
  {
    id: 13,
    opp: "University transfer application term",
    beginDate: "01 Aug, 2026",
    endDate: "31 Aug, 2026",
    duration: "",
  },
  {
    id: 14,
    opp: "Thesis defense Period",
    beginDate: "06 Aug, 2026",
    endDate: "23 Oct, 2026",
    duration: "",
  },
  {
    id: 15,
    opp: "Class starts 2026 – 2027",
    beginDate: "12 Sep, 2026",
    endDate: "",
    duration: "",
  },
];

export const sem1_2026_2027 = [
  {
    id: 1,
    opp: "Start of First Semester",
    beginDate: "12 Sep, 2026",
    endDate: "29 Jan, 2027",
    duration: "",
  },
  {
    id: 2,
    opp: "Classes begin",
    beginDate: "12 Sep, 2026",
    endDate: "06 Nov, 2026",
    duration: "8 weeks",
  },
  {
    id: 3,
    opp: "Midterm Exams",
    beginDate: "07 Nov, 2026",
    endDate: "13 Nov, 2026",
    duration: "1 week",
  },
  {
    id: 4,
    opp: "Classes resume",
    beginDate: "14 Nov, 2026",
    endDate: "01 Jan, 2027",
    duration: "7 weeks",
  },
  {
    id: 5,
    opp: "Final Exams",
    beginDate: "02 Jan, 2027",
    endDate: "08 Jan, 2027",
    duration: "1 week",
  },
  {
    id: 6,
    opp: "Oral Exams",
    beginDate: "09 Jan, 2027",
    endDate: "15 Jan, 2027",
    duration: "1 week",
  },
  {
    id: 7,
    opp: "Re-exams",
    beginDate: "23 Jan, 2027",
    endDate: "29 Jan, 2027",
    duration: "1 week",
  },
  {
    id: 8,
    opp: "End of First Semester",
    beginDate: "29 Jan, 2027",
    endDate: "",
    duration: "",
  },
  {
    id: 9,
    opp: "Break begin",
    beginDate: "16 Jan, 2027",
    endDate: "05 Feb, 2027",
    duration: "3 weeks",
  },
  {
    id: 10,
    opp: "University Transfer Application",
    beginDate: "30 Jan, 2027",
    endDate: "04 Feb, 2027",
    duration: "1 weeks",
  },
];